import LeadersCard from '@/components/Cards/LeadersCard'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import Container from '@/components/Container'
import HaveQuestionsSmall from '@/components/HaveQuestions/HaveQuestionsSmall'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import React from 'react'
import style from './styles/leaders_contacts.module.scss'
import { api } from '@/api'
import { dataStates } from '@garpix/fetcher'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'

const LeadersContacts = (): React.ReactElement => {
  const page = usePage()
  const { object } = page?.init_state

  return (
    <>
      <Container>
        <Title type='h1' className={style.contacts__title}>
          {object.title}
        </Title>
        <Section>
          <div className={style.contacts_grid}>
            <FetcherList
              isScrollTop={false}
              isHistoryPush={false}
              initFilter={{ page_size: 100 }}
              api={api.getContacts}
            >
              {({ results, status }) => {
                return (
                  <>
                    {status === dataStates.loading
                      ? (
                        <>
                          <div className={style.loader__wrapper}>
                            <PlaceholderLoading
                              shape='rect'
                              width='100%'
                              height='100%'
                            />
                          </div>
                          <div className={style.loader__wrapper}>
                            <PlaceholderLoading
                              shape='rect'
                              width='100%'
                              height='100%'
                            />
                          </div>
                          <div className={style.loader__wrapper}>
                            <PlaceholderLoading
                              shape='rect'
                              width='100%'
                              height='100%'
                            />
                          </div>
                        </>
                        )
                      : null}
                    {status === dataStates.loaded && results.length > 0
                      ? (
                        <>
                          {results.map(el => {
                            return (
                              <LeadersCard
                                key={el.id}
                                photo={el.property_avatar_value?.[0] ?? ''}
                                name={el.property_fio_value}
                                position={el.property_position_value}
                                phone={el.property_phone_value}
                                additionalPhone={el.property_ext_code_value}
                                email={el.property_email_value}
                                className={style.contacts__card}
                              />
                            )
                          })}
                        </>
                        )
                      : null}
                    {status === dataStates.loaded && results.length === 0
                      ? (
                        <p className={style.contacts__noresult}>
                          Контакты не найдены
                        </p>
                        )
                      : null}
                    {status === dataStates.failed
                      ? (
                        <p className={style.contacts__noresult}>
                          Произошла ошибка загрузки данных
                        </p>
                        )
                      : null}
                  </>
                )
              }}
            </FetcherList>
          </div>
        </Section>
      </Container>
      <HaveQuestionsSmall />
    </>
  )
}

export default LeadersContacts
